import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { makeStyles } from '@mui/styles';
import {
	Link
} from '@mui/material';

import DataTable from '../../../../../components/DataTable/DataTable.js';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	}
}));

const ActivityDetailsDataTable = (props) => {
	const { className, id, data, activityTasks, openTaskDetails, userId, changeColumnVisibility, visibleColumns, ...rest } = props;
	const classes = useStyles();
	const _getTableColumns = () => (
		[
			{
				name: 'id',
				label: 'Id',
				options: {
					display: false,
					filter: false,
					viewColumns: false,
					filterType: 'textField',
				}
			},
			{
				name: 'element',
				label: 'Element',
				options: {
					display: true,
					filterType: 'textField',
				}
			},
			...activityTasks.map((item, index) => ({
				name: `${item.activityTaskId}`,
				label: item.taskName,
				options: {
					display: (!(index > 10) && visibleColumns && visibleColumns.length === 0) || _.contains(visibleColumns, `${item.activityTaskId}`),
					filterType: 'textField',
					customBodyRender: (value, tableMeta, updateValue) => {
						const { rowData } = tableMeta;
						const element = _.find(data, el => el.element === rowData[1]);
						return (
							<Link
								component="button"
								variant="body2"
								onClick={
									() => { openTaskDetails(element[`elementTaskId_${item.activityTaskId}`]); }
								}
								underline="hover"
							>
								{value}
							</Link>
						);
					}
				}
			}))
		]
	);

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: false,
		// rowsExpanded,
		// expandableRows: activityTasks.length > 10, // Try Adding This
		// renderExpandableRow: (rowData, rowMeta) => {
		// 	const element = _.find(data, item => item.element === rowData[1]);
		// 	return (
		// 		<TableRow>
		// 			<TableCell colSpan={activityTasks.length}>
		// 				<Grid container style={{ padding: 3, width: '100%' }} spacing={3}>
		// 					{activityTasks.slice(11).map(item => (
		// 						<Fragment key={item.taskId}>
		// 							<Grid item lg={4} xs={6}>
		// 								{item.taskName}
		// 							</Grid>
		// 							<Grid item lg={8} xs={6}>
		// 								<Link
		// 									component="button"
		// 									variant="body2"
		// 									onClick={
		// 										() => { openTaskDetails(element[`elementTaskId_${item.taskId}`]); }
		// 									}
		// 								>
		// 									{element[item.taskId]}
		// 								</Link>
		// 							</Grid>
		// 						</Fragment>
		// 					)
		// 					)}
		// 				</Grid>
		// 			</TableCell>
		// 		</TableRow>
		// 	);
		// },
		// onRowsExpand: (currentRowsExpanded, allRowsExpanded) => {
		// 	const expanded = allRowsExpanded.map(
		// 		item => item.index
		// 	);

		// 	/* if (expanded.length > 1) {
		// 						// limiting would go here
		// 						expanded = expanded.slice(-1);
		// 		} */
		// 	setRowsExpanded(expanded);
		// }
		onViewColumnsChange: (changedColumn, action) => {
			const changeColumn = { userId, datatableId: id, columnId: changedColumn, action };
			changeColumnVisibility(changeColumn);
		}
	});

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<DataTable
				id={id}
				title="All Sites"
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={10}
				options={_getTableOptions()}
			/>
		</div>
	);
};

ActivityDetailsDataTable.propTypes = {
	className: PropTypes.object,
	id: PropTypes.string,
	data: PropTypes.array,
	activityTasks: PropTypes.array,
	openTaskDetails: PropTypes.func,
	userId: PropTypes.string,
	changeColumnVisibility: PropTypes.func,
	visibleColumns: PropTypes.array
};

export default ActivityDetailsDataTable;
